import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDetails'
})
export class formatDetails implements PipeTransform {
  transform(value: string): string {
    var data, dataVal
    if (value == null) {
      return '';
    }
    else {

      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return value.replace(urlRegex, function (url) {
        var hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
          hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" target="_blank" ></a>'
      });
    
    }

  }
}
